import { ViewPreference } from 'src/app/models';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';

import { AppState } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private StorageKey = 'pdo_settings';
  private state: AppState;

  constructor() {
    this.state = this.getInitialStateFromStorageOrDefault();
  }

  getState(): Observable<AppState> {
    return of(this.state);
  }

  patchLanguage(language: string) {
    this.state = { ...this.state, selectedLanguage: language };

    this.saveState();
  }

  patchViewPreference(preference: ViewPreference) {
    this.state = { ...this.state, viewPreference: preference };

    this.saveState();
  }

  private saveState() {
    localStorage.setItem(this.StorageKey, JSON.stringify(this.state));
  }

  private getInitialStateFromStorageOrDefault() {
    const savedState = localStorage.getItem(this.StorageKey);
    if (savedState) {
      return JSON.parse(savedState);
    }

    return {
      selectedLanguage: '',
      viewPreference: {
        showEfficiency: true,
        showSlidingVelocity: true,
        showSpeed100VolumetricEfficiency: true,
        showTolerances: false,
        showNpshrLow: false,
        useImperialUnits: false,
      },
    };
  }
}
